import api from '@/services/api';

export default {
  async getUnitTypes(propertyId) {
    try {
      let response = await api.get(`UnitTypes?propertyId=${propertyId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getProjectedVacancies(propertyId, asOfDate) {
    try {
      let response = await api.get(`UnitTypes/ProjectedVacancies?propertyId=${propertyId}&asOfDate=${asOfDate.toISOString()}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }
}
